import { RouteObject, redirect } from 'react-router-dom';
import { routeAccount } from './app/components/account/account.route';
import { routeEditCommPreferences } from './app/components/account/components/edit-comm-preferences/edit-comm-preferences.route';
import { routeEditMembership } from './app/components/account/components/edit-membership/edit-membership.route';
import { routeEditPersonalInfo } from './app/components/account/components/edit-personal-info/edit-personal-info.route';
import { routeActionPlan } from './app/components/action-plan/action-plan.route';
import { routeBuildActionPlan } from './app/components/action-plan/components/build-action-plan/build-action-plan.route';
import { routeDashboard } from './app/components/dashboard/dashboard.route';
import { routeLoadingScreen } from './app/components/loading-screen/loading-screen.route';
import { routePayment } from './app/components/payment/payment.route';
import { routeQuestionnaire } from './app/components/questionnaire/questionnaire.route';
import { routeRiskAnalysis } from './app/components/risks/risk-analysis/risk-analysis.route';
import { routeRiskTrend } from './app/components/risks/risk-trend/risk-trend.route';
import { routeSingleCancerView } from './app/components/risks/single-cancer-view/single-cancer-view.route';
import { routeAuthMagic } from './app/components/auth-magic/auth-magic.route';
import { routeSignIn } from './app/components/sign-in/sign-in.route';
import { routeSignUp } from './app/components/sign-up/sign-up.route';
import { routeTestDetails } from './app/components/testing-plan/components/test-details/test-details.route';
import { routeTestingPlanComplete } from './app/components/testing-plan/components/your-testing-plan/components/complete-test/complete-test.route';
import { routeTestingPlan } from './app/components/testing-plan/testing-plan.route';
import { routeWearables } from './app/components/wearables/wearables.route';
import { routeLabs } from './app/components/labs/labs.route';
import { routeLabsAll } from './app/components/labs/labs-all.route';
import { routeBiomarkerDetail } from './app/components/labs/components/biomarker-detail/biomarker-detail.route';
import { routeLabsOrder } from './app/components/labs-order/labs-order.route';
import { routeConsent } from './app/components/consent/consent.route';
import { routeHealthData } from './app/components/health-data/health-data.route';
import Layout from './components/layout-auth/layout-auth';
import MainLayout from './components/main-layout/main-layout';
import {
  ROUTE_SIGN_IN,
  ROUTE_SIGN_UP,
} from './constants/routes';
import authService from './services/auth.service';
import { routeQuizletVariant } from './app/components/quizletv2/quizlet-variant.route';
import { generateAllQuizletRoutes } from './app/components/quizletv2/quizlet-generic.route';
import { getEnabledQuizletVersions } from './app/components/quizletv2/quizlet-config';
import { routeQuestionnaireV2 } from './app/components/questionnaireV2/components/questionnaireV2.route';
import { routeRiskScoreReveal } from './app/components/risk-score-reveal/risk-score-reveal.route';
import { routeMultiDiseaseWelcome } from './app/components/multi-disease-welcome/multi-disease-welcome.route';

// Redirect removed routes to sign-up
const deadRouteRedirect = (path: string): RouteObject => ({
  path,
  loader: () => redirect(ROUTE_SIGN_UP),
});

const router: Array<RouteObject> = [
  {
    loader() {
      if (!authService.isLoggedIn()) {
        return redirect(ROUTE_SIGN_IN);
      }
      return null;
    },
    children: [
      {
        Component: MainLayout,
        children: [
          routeAccount,
          routeEditPersonalInfo,
          routeActionPlan,
          routeQuestionnaire,
          routeTestingPlan,
          routeTestDetails,
          routeTestingPlanComplete,
          routeDashboard,
          routeBuildActionPlan,
          routeEditMembership,
          routeRiskAnalysis,
          routeRiskTrend,
          routeSingleCancerView,
          routeEditCommPreferences,
          routeLoadingScreen,
          routeMultiDiseaseWelcome,
          routeQuestionnaireV2,
          routeRiskScoreReveal,
          routeWearables,
          routeLabs,
          routeLabsAll,
          routeBiomarkerDetail,
          routeLabsOrder,
          routeConsent,
          routeHealthData,
        ],
      },
    ],
  },
  {
    Component: Layout,
    children: [
      routeAuthMagic,
      routeSignUp,
      routeSignIn,
      routePayment,
      // Active quizlet routes (v6 flow)
      routeQuizletVariant,
      ...generateAllQuizletRoutes(getEnabledQuizletVersions()),

      // Dead routes — catch-all redirects to sign-up
      deadRouteRedirect('/free-assessment/*'),
      deadRouteRedirect('/free-assessment'),
      deadRouteRedirect('/early-access/*'),
      deadRouteRedirect('/early-access'),
      deadRouteRedirect('/quiz/*'),
      deadRouteRedirect('/quiz'),
    ],
  },
];

export default router;
